import React from "react";
import Section from "./Section";
import ResumeBuilderComponent from './ResumeBuilder';
// import ResumeBuilderComponent from "../ResumeBuilder/ResumeBuilder";

const ResumeBuilder = () => {
    document.title = "Resume Builder - Matrix Executive Search Group";
    return (
        <React.Fragment>
            <Section />
            <ResumeBuilderComponent />
        </React.Fragment>
    );
};

export default ResumeBuilder;
